import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDocs, collection, doc, deleteDoc } from "firebase/firestore";
import db from "../firestore";
import Header from "../Components/Header";

function ManageBlog() {
  const [blogs, setBlogs] = useState([]);

  const fetchBlogs = async () => {
    const data = await getDocs(collection(db, "Blog"));
    setBlogs(data.docs.map((d) => ({ ...d.data(), id: d.id })));
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const deletePost = async (id) => {
    await deleteDoc(doc(db, "Blog", id));
    setBlogs((prev) => prev.filter((b) => b.id !== id));
  };

  return (
    <div className="adminDashboard">
      <Header />
      <div className="adminDashContent w-screen flex flex-col items-center">
        <div className="Blogs w-3/4 border rounded p-5 mt-5">
          <div className="flex w-full justify-between items-center pb-5">
            <h1 className="font-bold text-2xl">Blogs</h1>
            <Link to="/dashboard/addBlog">
              <button className="rounded bg-add-green px-5 py-2 text-white hover:bg-add-green2">
                + Add
              </button>
            </Link>
          </div>
          {blogs.map((item) => (
            <div className="border p-5 mb-5" key={item.id}>
              <h1 className="font-bold text-xl">{item.Title}</h1>
              <p>{item.Date}</p>
              <button
                className="rounded bg-delete-red px-5 py-2 mt-10 text-white hover:bg-delete-red2"
                onClick={() => deletePost(item.id)}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ManageBlog;
